import { Grid } from "@mui/material";
import Progamar_Consulta from "./Componentes/Progamar_Consulta";
import { Helmet } from "react-helmet";

const Seccion_Consulta = () => {
    return (
        <>
            <Helmet>
                {/* 🔹 Title optimizado (intención de conversión) */}
                <title>Contacta Visita Técnica en Cali | Mantenimiento Locativo y SST</title>

                {/* 🔹 Meta descripción (≤155 caracteres) */}
                <meta
                    name="description"
                    content="Agenda una visita técnica en Cali para mantenimiento locativo y adecuaciones con cumplimiento SST en empresas y copropiedades."
                />

                {/* 🔹 Keywords */}
                <meta
                    name="keywords"
                    content="mantenimiento locativo Cali, visita técnica Cali, adecuaciones locativas, SST Colombia, cotización mantenimiento"
                />

                {/* 🔹 Canonical */}
                <link rel="canonical" href="https://espaciocompacto.com/contacto/" />

                {/* 🔹 Open Graph */}
                <meta property="og:title" content="Contacta Visita Técnica en Cali | Espacio Compacto" />
                <meta
                    property="og:description"
                    content="Solicita tu visita técnica para mantenimiento locativo y adecuaciones en Cali con cumplimiento SST."
                />
                <meta property="og:url" content="https://espaciocompacto.com/contacto/" />
                <meta property="og:type" content="website" />
                <meta property="og:image" content="https://espaciocompacto.com/Espaci_Compacto.png" />

                {/* 🔹 Twitter */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Contacta Visita Técnica en Cali" />
                <meta
                    name="twitter:description"
                    content="Agenda tu servicio de mantenimiento locativo y adecuaciones en Cali."
                />
                <meta name="twitter:image" content="https://espaciocompacto.com/Espaci_Compacto.png" />

                {/* 🔹 JSON-LD (Service + ContactAction) */}
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "Service",
                        name: "Mantenimiento Locativo y Adecuaciones Técnicas",
                        provider: {
                            "@type": "Organization",
                            name: "Espacio Compacto",
                            url: "https://espaciocompacto.com"
                        },
                        areaServed: {
                            "@type": "Place",
                            name: "Cali, Colombia"
                        },
                        potentialAction: {
                            "@type": "ContactAction",
                            target: "https://espaciocompacto.com/contacto/",
                            name: "Contacta visita técnica"
                        }
                    })}
                </script>
            </Helmet>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'center'}
                size={{ xs: 12, sm: 12, md: 12 }}
            >
                <Grid
                    container
                    justifyContent={'center'}
                    alignItems={'center'}
                    size={{ xs: 12, sm: 12, md: 12 }}
                >
                    <Progamar_Consulta />
                </Grid>
            </Grid>
        </>
    );
};
export default Seccion_Consulta;
